"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { getLanguage } from "../../../../../utils/index.js";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { VideoPlayer } from "@nxt-costco-com/forge-components";
import { SpaceMd, SpaceLg, SpaceXs } from "@nxt-costco-com/forge-design-tokens";
import { Analytics } from "../../../../Analytics/index.js";
import { VideoSpotlightMainContainer } from "../styles.js";
import { ProductTileCarouselClient } from "../../ProductTileCarousel/ProductTileCarouselClient.js";
import { AdSetContainerStyles } from "../../styles.js";
import { CostcoBox } from "../../../../Util/CostcoBox.js";
import { useCheckScreen } from "../../../../../hooks/useCheckScreen/index.js";
import { LegalText } from "./LegalText.js";
const VideoSpotlightDefault = ({
  contentStackEntry = {},
  locale,
  ParentSKUs,
  productTileSx,
  sx = {},
  testId,
  analytics,
  carouselA11yInformation,
  videoInformation,
  videoBeacons,
  isPdp = false,
  isCriteo = false
}) => {
  var _a;
  const theme = useTheme();
  const { isBiggerDesktop, isTablet, isMobile } = useCheckScreen();
  const isSmTablet = useMediaQuery(
    `(min-width: ${theme.breakpoints.values.md}px) and (max-width: 916px)`
  );
  const {
    product_card_display_style,
    show_reviews,
    show_action_button,
    inventory_aware_listings,
    product_tile_data_source
  } = (contentStackEntry == null ? void 0 : contentStackEntry.product_display_style) || {};
  let maxProductTileImageWidth = "30%";
  if (isBiggerDesktop) {
    maxProductTileImageWidth = "40%";
  }
  if (!(ParentSKUs.length > 1)) {
    maxProductTileImageWidth = "20%";
  }
  const isSmall = isMobile || isSmTablet;
  return /* @__PURE__ */ jsxs(
    VideoSpotlightMainContainer,
    {
      sx: {
        ...AdSetContainerStyles,
        ...sx
      },
      "data-testid": testId,
      isMobile: isSmall,
      isSmall,
      children: [
        /* @__PURE__ */ jsx(
          CostcoBox,
          {
            sx: {
              borderTopLeftRadius: isSmall ? "10px" : void 0,
              borderTopRightRadius: isSmall ? "10px" : void 0,
              display: "flex",
              justifyContent: "center",
              minWidth: isSmall ? "100%" : void 0,
              overflow: isSmall ? "hidden" : void 0
            },
            children: /* @__PURE__ */ jsxs(
              CostcoBox,
              {
                sx: {
                  display: "flex",
                  flexDirection: "column",
                  maxWidth: !isSmall ? "444.44px" : "640px",
                  minWidth: !isSmall ? "444.44px" : void 0,
                  width: isSmall ? "100%" : void 0
                },
                children: [
                  /* @__PURE__ */ jsx(
                    CostcoBox,
                    {
                      sx: {
                        borderBottomLeftRadius: !isSmall && isPdp && !videoInformation.legalText ? { md: "10px" } : isPdp ? "" : videoInformation.legalText ? "" : { md: "10px" },
                        borderTopLeftRadius: !isSmTablet ? "10px" : 0,
                        borderTopRightRadius: isMobile ? "10px" : 0,
                        height: !isSmall ? "250px" : "100%",
                        overflow: "hidden"
                      },
                      children: /* @__PURE__ */ jsx(
                        VideoPlayer,
                        {
                          analytics: videoBeacons,
                          controlBarStyles: "justify-content:center",
                          language: getLanguage(locale),
                          options: videoInformation.options
                        }
                      )
                    }
                  ),
                  videoInformation.legalText && /* @__PURE__ */ jsx(
                    LegalText,
                    {
                      isSmall,
                      text: videoInformation.legalText,
                      variant: "default"
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(
          CostcoBox,
          {
            sx: {
              display: "flex",
              flex: 1,
              height: "100%",
              padding: !isSmall ? `${SpaceXs} 0 ${SpaceXs} ${SpaceLg}` : 0,
              paddingLeft: !isSmall ? SpaceLg : 0,
              paddingTop: isSmall ? SpaceMd : void 0,
              position: "relative"
            },
            children: /* @__PURE__ */ jsx(
              Analytics,
              {
                analyticData: {
                  adItem: {
                    style: "carousel",
                    title: (_a = contentStackEntry == null ? void 0 : contentStackEntry.ad_set_heading_and_costco_url) == null ? void 0 : _a.title,
                    type: "product"
                  },
                  title: contentStackEntry.title
                },
                children: /* @__PURE__ */ jsx(
                  ProductTileCarouselClient,
                  {
                    isProductDetailsPage: isPdp,
                    containerSx: {
                      justifyContent: "center",
                      maxWidth: isSmall ? "100%" : void 0,
                      padding: !isSmall ? `0 ${SpaceMd}` : `0`
                    },
                    disableBottomControls: !isSmall && ParentSKUs.length > 1,
                    maxProductTileImageHeight: !isSmall ? "100%" : void 0,
                    productTileContainerSx: {
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                      padding: 1,
                      ...isPdp && { height: void 0 }
                    },
                    productTileNumberSeparator: carouselA11yInformation.productTileNumberSeparator,
                    productTileSx: {
                      ...productTileSx,
                      marginBottom: 0,
                      maxWidth: !isSmall && ParentSKUs.length > 1 ? "480px" : "100%"
                    },
                    sx: {
                      alignItems: "center",
                      display: "flex",
                      height: "100%",
                      ...isSmall && isPdp && { marginBottom: SpaceMd }
                    },
                    analytics,
                    ariaLabel: carouselA11yInformation.carouselLabel,
                    criteoDataSourceAttr: true,
                    displayMultipleTiles: !isSmall && ParentSKUs.length > 1,
                    hideReviewStarValue: true,
                    inventoryAware: inventory_aware_listings,
                    isHorizontal: true,
                    itemNumbers: ParentSKUs,
                    locale,
                    maxProductTileImageWidth,
                    maxSlides: 1,
                    minProductTileImageWidth: maxProductTileImageWidth,
                    navigationButtonBottomOffset: "40%",
                    navigationButtonsBottomAlign: isSmall,
                    navigationButtonsMobileDisplay: isSmall,
                    pageType: "homepage",
                    productTileMaxLineNumber: 1,
                    showActionButton: show_action_button,
                    showReviews: show_reviews,
                    showSlideNumber: isTablet && ParentSKUs.length > 1,
                    testId,
                    variant: product_card_display_style,
                    product_tile_data_source,
                    isCriteo
                  }
                )
              }
            )
          }
        )
      ]
    }
  );
};
export {
  VideoSpotlightDefault
};
